import Vue from 'vue'
import Router from 'vue-router'
import layout from "@/layout"
import home from '@/view/home'
import inteManufa from '@/view/inteManufa'
import aipeople from '@/view/aipeople'
import countryside from '@/view/countryside'


Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    component: layout,
    redirect: 'home',
    children: [{
      path: '/home',
      name: 'home',
      component: home
    }, {
      path: '/inteManufa',
      name: 'inteManufa',
      component: inteManufa
    }, {
      path: '/aipeople',
      name: 'aipeople',
      component: aipeople
    }, {
      path: '/countryside',
      name: 'countryside',
      component: countryside
    }, ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js